import { Component, signal, ChangeDetectorRef, ViewChild, ViewContainerRef } from '@angular/core';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi, EventInput } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import esLocale from '@fullcalendar/core/locales/es';
import { INITIAL_EVENTS, createEventId } from './events-utils';
import { ITaskAppointmentFilter, ITask } from '../../tasks-page/tasks/task.interface';
import { AppointmentsService } from '../../tasks-page/tasks/appoinment/appointment.service';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { AuthService } from '../../../shared/services/auth.service';
import moment from 'moment';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TaskModalComponent } from '../../tasks-page/tasks/task-modal/task-modal.component';
import { TaskSingleComponent } from '../../tasks-page/tasks/task-single/task-single.component';
import { IClient } from '../../clients-page/clients/clients.interface';
import { IWorker } from '../../workers-page/workers/workers.interface';
import { ClientsService } from '../../clients-page/clients/clients.service';
import { WorkersService } from '../../workers-page/workers/workers.service';
import _ from 'lodash';
import { SETTINGS } from '../../settings-page/settings/settings.constants';
import { SettingsService } from '../../settings-page/settings/settings.service';
import { FeaturesService } from '../../features-page/features/features.service';

let self: any;
@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css'],
})

export class CalendarComponent {
  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  task: ITask = {};
  filter: ITaskAppointmentFilter = {
    sort: '',
    skip: 0,
    limit: 2000,
    filters: {
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      status: 'ACTIVE',
      isDeleted: false
    },
  };
  calendarVisible = signal(true);

  calendarOptions = signal<CalendarOptions>({
    locale: esLocale,
    plugins: [
      interactionPlugin,
      dayGridPlugin,
      timeGridPlugin,
      listPlugin,
      bootstrap5Plugin
    ],
    themeSystem: 'bootstrap5',
    headerToolbar: {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    initialView: 'dayGridMonth',
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    eventDisplay: 'block', // Asegura que el fondo se aplique correctamente
    select: this.handleDateSelect.bind(this),
    eventClick: this.handleEventClick.bind(this),
    eventsSet: this.handleEvents.bind(this),
    datesSet: this.handleNavigation.bind(this), // Manejar cambios en fechas o navegación
    viewDidMount: this.handleViewChange.bind(this), // Manejar cambio de vista
    events: [],
  });

  currentEvents = signal<EventApi[]>([]);
  appointmentsData: any[] = [];

  workers: IWorker[] = [];
  workersFilter: string[] = [];
  clients: IClient[] = [];
  clientsFilter: string[] = [];
  statusFilter: string = '';

  settings: any = [];
  feature: any = [];
  colorStatusOpen: string = "";
  colorStatusScheduled: string = "";
  colorStatusInvoiced: string = "";
  colorStatusOnGoing: string = "";
  colorStatusCompleted: string = "";
  colorStatusCancelled: string = "";

  constructor(
    private changeDetector: ChangeDetectorRef,
    private _AppointmentService: AppointmentsService,
    private _WorkersService: WorkersService,
    private _ClientsService: ClientsService,
    private _SettingsService: SettingsService,
    private _FeaturesService: FeaturesService,
    private _AuthService: AuthService,
    private _dialog: MatDialog,
    private _viewContainerRef: ViewContainerRef,
  ) {
    self = this;
  }

  setStatusColor() {
    let open = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_OPEN_COLOR);
    this.colorStatusOpen = open[0].companySetting != null ? open[0].companySetting.value : open[0].defaultValue;

    let scheduled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_SCHEDULED_COLOR);
    this.colorStatusScheduled = scheduled[0].companySetting != null ? scheduled[0].companySetting.value : scheduled[0].defaultValue;

    let invoiced = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_INVOICED_COLOR);
    this.colorStatusInvoiced = invoiced[0].companySetting != null ? invoiced[0].companySetting.value : invoiced[0].defaultValue;

    let ongoing = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_ONGOING_COLOR);
    this.colorStatusOnGoing = ongoing[0].companySetting != null ? ongoing[0].companySetting.value : ongoing[0].defaultValue;

    let completed = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_COMPLETED_COLOR);
    this.colorStatusCompleted = completed[0].companySetting != null ? completed[0].companySetting.value : completed[0].defaultValue;

    let cancelled = this.settings.filter((e: any) => e.code == SETTINGS.SCH_TASK_CANCELLED_COLOR);
    this.colorStatusCancelled = cancelled[0].companySetting != null ? cancelled[0].companySetting.value : cancelled[0].defaultValue;
  }

  getColorForStatus(status: string): string {
    switch (status) {
      case 'OPEN':
      case 'QUOTED': {
        return this.colorStatusOpen;
      }
      case 'SCHEDULED':
        return this.colorStatusScheduled;
      case 'ONGOING':
        return this.colorStatusOnGoing;
      case 'COMPLETED':
        return this.colorStatusCompleted;
      case 'INVOICED':
        return this.colorStatusInvoiced;
      case 'CANCELLED':
        return this.colorStatusCancelled;
      default:
        return '#cccccc'; // Color por defecto para estados desconocidos
    }
  }

  handleNavigation(info: any) {
    const { start, end } = info; // Rango visible del calendario

    this.filter.filters.startDate = start.toISOString();
    this.filter.filters.endDate = end.toISOString();

    console.log('Updated Filter for Navigation:', {
      startDate: this.filter.filters.startDate,
      endDate: this.filter.filters.endDate,
    });

    this.getAppointments(); // Llama al método para obtener citas actualizadas
  }

  handleViewChange(info: any) {
    const { activeStart, activeEnd } = info.view; // Rango visible de la vista actual

    this.filter.filters.startDate = activeStart.toISOString();
    this.filter.filters.endDate = activeEnd.toISOString();

    console.log('Updated Filter for View Change:', {
      startDate: this.filter.filters.startDate,
      endDate: this.filter.filters.endDate,
    });

    this.getAppointments(); // Llama al método para obtener citas actualizadas
  }


  applyFilters() {
    this.filter.filters.workers = this.workersFilter;
    this.filter.filters.clients = this.clientsFilter;
    this.filter.filters.status = this.statusFilter;

    this.getAppointments(); // Actualiza los eventos en el calendario
  }

  applyStatusFilter(status: string) {
    this.statusFilter = status;
    this.applyFilters();
  }


  ngOnInit() {
    this.filter.company = this._AuthService.companyId();

    this._FeaturesService.getFeatures({ filters: { name: "Agenda" } }).subscribe((feature) => {
      this.feature = feature;
      this._SettingsService.getCompanySettingByFeature({ company: this._AuthService.companyId(), filters: { feature: feature[0]["_id"] } }).subscribe((settings) => {
        this.settings = settings;
        this.getAppointments(new Date());
        this.setStatusColor();
      });
    });
    this._WorkersService.getWorkers({ limit: 500, skip: 0, company: this._AuthService.companyId(), filters: { isDeleted: false } }).subscribe((workers) => {
      this.workers = workers;
      this.workers = _.orderBy(this.workers, ['firstname', 'lastname'], ['asc', 'asc']);
    });
    this._ClientsService.getClients({ limit: 500, skip: 0, company: this._AuthService.companyId(), sort: "firstname", filters: { isDeleted: false } }).subscribe((clients) => {
      this.clients = clients;
      this.clients = _.orderBy(this.clients, ['firstname'], ['asc']);
    });

    this.getAppointments(new Date());
  }

  calculateDayFilter(e = new Date()) {
    const filter: any = this.filter;
    filter.filters.startDate = new Date(e.getFullYear(), e.getMonth() - 1, 20).toISOString();
    filter.filters.endDate = new Date(e.getFullYear(), e.getMonth() + 1, 10, 23, 59, 59).toISOString();
  }

  getAppointments(e?: any) {

    if (e) {
      this.calculateDayFilter(e)
    }

    this._AppointmentService.getAppointmentsReduce(this.filter).subscribe((appointments: any) => {
      this.appointmentsData = appointments.map((a: any) => {
        let backgroundColor = this.getColorForStatus(a.task.status);

        return {
          title: `${a.client.firstname} ${a.client.lastname} | ${a.task.title || ''}`,
          start: new Date(a.startDate),
          end: new Date(a.endDate),
          backgroundColor, // Color del fondo
          borderColor: backgroundColor, // Color del borde opcional
          extendedProps: {
            task: a.task,
            client: a.client,
            status: a.task.status,
          },
        };
      });

      this.calendarOptions.set({ events: this.appointmentsData });
      let calendarApi = this.calendarComponent.getApi();
      calendarApi.render();
    });
  }

  handleCalendarToggle() {
    this.calendarVisible.update((bool) => !bool);
  }

  handleWeekendsToggle() {
    this.calendarOptions.update((options) => ({
      ...options,
      weekends: !options.weekends,
    }));
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    /*const title = prompt('Please enter a new title for your event');
    const calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: createEventId(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }*/
    //Pasar todo a un evento
    this.task.status = 'SCHEDULED';
    this.task.scheduledStart = new Date(selectInfo.startStr);
    this.task.scheduledEnd = new Date(selectInfo.endStr);
    let config = new MatDialogConfig();

    config.width = '1300px';
    config.maxWidth = '90vw';
    config.panelClass = 'calendar-task';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(TaskModalComponent, config);
    self.dialogRef.componentInstance.task = this.task;
    self.dialogRef.componentInstance.readOnly = false;
    self.dialogRef.componentInstance.scheduling = true;
    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
    self.dialogRef.backdropClick().subscribe(() => {
      //recargar luego de agregar la tarea
      self.dialogRef = null;
    });

  }

  handleEventClick(clickInfo: EventClickArg) {
    //Pasar todo a un evento
    if (clickInfo.event) {
      let event = clickInfo.event.toJSON();
      let config = new MatDialogConfig();
      config.width = '1300px';
      config.maxWidth = '90vw';
      config.panelClass = 'calendar-task';
      config.viewContainerRef = this._viewContainerRef;
      config.disableClose = true;
      config.hasBackdrop = true;
      self.dialogRef = this._dialog.open(TaskSingleComponent, config);
      self.dialogRef.componentInstance.task = event['extendedProps']['task'];
      self.dialogRef.componentInstance.readOnly = true;
      self.dialogRef.afterClosed().subscribe((result: any) => {
        self.dialogRef = null;
      });
      self.dialogRef.backdropClick().subscribe(() => {
        //Recargar luego del edit
        self.dialogRef = null;
      });
    }

  }

  handleEvents(events: EventApi[]) {
    this.currentEvents.set(events);
    this.changeDetector.detectChanges(); // workaround for pressionChangedAfterItHasBeenCheckedError
  }

  formatDateString(dateString: any) {
    //console.log(dateString);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    const hours = dateString.substring(11, 13);
    const minutes = dateString.substring(14, 16);

    const monthNames = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];

    const monthName = monthNames[parseInt(month, 10) - 1];

    const ampm = (parseInt(hours) > 12) ? 'pm' : 'am';

    return `${day} de ${monthName} ${hours}:${minutes}`;
  }

  formatDateStringToHM(dateString: any) {

    const hours = dateString.substring(11, 13);
    const minutes = dateString.substring(14, 16);

    const ampm = (parseInt(hours) > 12) ? 'pm' : 'am';

    return `${hours}:${minutes}`;

  }

  onSelectWorker() {
    if (this.workersFilter.length > 1) {
      if (this.workersFilter[0] == 'notAsigned') {
        this.workersFilter = this.workersFilter.slice(1);
        // this.totalHs = 0;
      }
    }
    this.applyFilters()
  }

  onSelectWorkerNotAsigned() {
    this.workersFilter = this.workersFilter.slice(0, 1)
    this.applyFilters();
    // this.totalHs = 0;
  }

  onSelectClient() {
    if (this.workersFilter.length > 1) {
      if (this.workersFilter[0] == 'notAsigned') {
        this.workersFilter = this.workersFilter.slice(1);
        // this.totalHs = 0;
      }
    }
    this.applyFilters()
  }

}